import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';
import { parseJsonToFormData, request } from './helper';

export function setTrackers(trackers) {
	if (trackers){
		Object.entries(trackers).forEach(
			([key, value]) => {
				if (value.type === 'FB'){
					const options = {
						autoConfig: true,
						debug: false
					};

					try {
						ReactPixel.init(value.code, {}, options);
						value.ref = ReactPixel;
					} catch(e) {}
				}
				else if (value.type === 'GOOGL') {
					try {
						ReactGA.initialize(value.code);
						// ReactGA.pageview(window.location.pathname);
						value.ref = ReactGA;
					} catch(e) {}
				}
				else {
					// no initialization for others ---
				}
			}
		);
	}
	return trackers;
}

export function trackEvent(trackers, event, tag, eventDataObj, logDataEvent) {
	let subcategory = tag && tag.settings && tag.settings.subcategory;
	let subcategoryEngagement =	subcategory && subcategory[0] && subcategory[0].engagements && subcategory[0].engagements[0];
	let engSlug = subcategoryEngagement && subcategoryEngagement.slug;

	let tag_id = tag && tag.id;
	let tag_title = tag && tag.details && (tag.details.preview_title || tag.details.title);
	let video_title = eventDataObj.video_title;
	let tag_duration = eventDataObj.tag_duration;
	let eng_label =	subcategoryEngagement && subcategoryEngagement[`label|${engSlug}`];
	let sub_objective = subcategory && subcategory[0] && subcategory[0].name;
	let cat_type = tag && tag.settings && tag.settings.category;
	let sub_cat_type = subcategory && subcategory[0] && subcategory[0].type;
	let view_event = eventDataObj.view_event;
	const gate_response = eventDataObj.gate_response;
	const emotion = eventDataObj.emotion;
	let macros = {
		tag_id,
		tag_title,
		tag_duration,
		eng_label,
		sub_objective,
		cat_type,
		sub_cat_type,
		video_title,
		view_event,
		gate_response,
		emotion,
	};

	let eventMacros = [];
	let fbEventName = '';
	let enabledTagTrackers = (tag && tag.target && tag.target.trackers) || [];

	switch (event) {
		case 'ViewContent':
			eventMacros = ['tag_title', 'video_title', 'tag_duration'];
			fbEventName = 'ViewContent';
			break;
		case 'AddToCart':
			switch (macros.cat_type) {
				case 1:
					eventMacros = ['tag_title', 'video_title'];
					break;
				case 8:
					eventMacros = ['tag_title', 'video_title', 'eng_label'];
					break;
			}
			fbEventName = 'AddToCart';
			break;
		case 'Lead':
			switch (macros.cat_type) {
				case 9:
				case 12:
					eventMacros = ['tag_title', 'video_title'];
					break;
				case 10:
					eventMacros = ['tag_title', 'video_title', 'sub_objective'];
					break;
			}
			fbEventName = 'Lead';
			break;
		case 'LeadTagEvents':
			switch (macros.sub_cat_type) {
				case 900:
					eventMacros = ['tag_title', 'video_title', 'selected_poll'];
					break;
				case 903:
					eventMacros = ['tag_title', 'video_title', 'gate_response'];
					break;
				case 1602:
					eventMacros = ['tag_title', 'video_title', 'emotion'];
					break;
			}
			fbEventName = 'Lead';
			break;
		case 'Impression':
			eventMacros = ['tag_title', 'video_title', 'sub_objective'];
			fbEventName = 'Impression';
			break;
	}

	// View Tracking - tracks on video play
	if (trackers && event === 'VideoViewTracking') {
		let viewEventMacros = ['video_title', 'view_event'];
		let clientSelectedMacros = ['video_title', 'view_event'];
		let macrosToSend = filterMacros(viewEventMacros, clientSelectedMacros, macros);
		let fbEventName = 'ViewContent';
		Object.entries(trackers).forEach(
			([key, value]) => {
				const trackViewEnabled = value.meta.filter(item => item==='track_view').length;
				const eventKey = eventDataObj.event_key; // can be one of [0,25,50,75,100]
				let keyEnabled = true;
				if (value.view_tracking_enabled) {
					keyEnabled = !!value.view_tracking_enabled.filter(num => num === eventKey).length;
				}
				if (trackViewEnabled && keyEnabled){
					if (value.type === 'FB') {
						value.ref.track(fbEventName, macrosToSend);
					}
					else if (value.type === 'GOOGL'){
						value.ref.set({ dimension1: JSON.stringify(macrosToSend) });
						value.ref.ga('send', 'dimension1');
						value.ref.event({ category: fbEventName, action: fbEventName });
					}
					else {
						macrosToSend = Object.assign( { event: fbEventName }, macrosToSend);
						let urlParameters = parseJsonToFormData(macrosToSend);
						let trackerUrl = value.code && value.code.toString();
						if (trackerUrl){
							let operator = trackerUrl.indexOf('?') !== -1 ? '&' : '?';
							trackerUrl = trackerUrl.replace('[timestamp]', Date.now());
							let url = `${trackerUrl}${operator}${urlParameters}`;
							request(url, { mode: 'no-cors' });
						}
					}
				}
			}
		);
	}

	if (trackers){
		Object.entries(trackers).forEach(
			([key, value]) => {
				if (enabledTagTrackers.join('^').indexOf(key) !== -1){
					let macrosToSend = {};
					if (value.type === 'FB'){
						let clientSelectedMacros = value.micros;
						macrosToSend = filterMacros(eventMacros, clientSelectedMacros, macros);
						//console.log(fbEventName, macrosToSend);
						value.ref.track(fbEventName, macrosToSend);
					}
					else if (value.type === 'GOOGL'){
						let clientSelectedMacros = value.micros;
						macrosToSend = filterMacros(eventMacros, clientSelectedMacros, macros);

						value.ref.set({ dimension1: JSON.stringify(macrosToSend) });
						value.ref.ga('send', 'dimension1');
						value.ref.event({ category: fbEventName, action: fbEventName });
					}
					else {
						let clientSelectedMacros = value.micros;
						macrosToSend = filterMacros(eventMacros, clientSelectedMacros, macros);
						// in NON-google/fb case event will be sent as extra parameter to url---
						macrosToSend = Object.assign( { event: fbEventName }, macrosToSend);

						let urlParameters = parseJsonToFormData(macrosToSend);
						let trackerUrl = value.code;
						if (trackerUrl){
							let operator = trackerUrl.indexOf('?') !== -1 ? '&' : '?';
							trackerUrl = trackerUrl.replace('[timestamp]', Date.now());
							let url = `${trackerUrl}${operator}${urlParameters}`;
							request(url, { mode: 'no-cors' });
							// let wnd = window.open(url);
							// if (wnd){
							// 	wnd.close();
							// }
						}
					}
					//log data event for stats---
					statsDataEvent(macrosToSend, tag, fbEventName, value.type, logDataEvent);
				}
			}
		);
	}
}

function filterMacros(eventMacros, clientSelectedMacros, macros) {
	let macrosToSend = {};
	// modifying for age gate to include `gate_response` as it is not in the checkbox list in dashboard for client to select---
	if (eventMacros.includes('gate_response')) {
		clientSelectedMacros.push('gate_response');
	}
	// for social emotion
	if (eventMacros.includes('emotion')) {
		clientSelectedMacros.push('emotion');
	}
	//---


	eventMacros.forEach(macro => {
		if (clientSelectedMacros && clientSelectedMacros.indexOf(macro) !== -1) {
			macrosToSend[macro] = macros[macro];
		}
	});
	return macrosToSend;
}

function statsDataEvent(macrosToSend, tag, trackerEventType, eventType, logDataEvent){
	let tag_id = tag && tag.id;
	let tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);
	let engagement_data = Object.assign(macrosToSend, { tracker_event_type: trackerEventType });
	let logDataObj = {
		sub_type: null,
		event: 'tracker',
		event_type: eventType,
		tag_id,
		tag_label,
		engagement_data: JSON.stringify(engagement_data)
	};
	logDataEvent(logDataObj);
}


// WEBPACK FOOTER //
// ./components/tracker.js